const List = {
  defaultProps: {},
  styleOverrides: {
    root: () => ({
      display: "flex",
      flexDirection: "column",
      gap: 16,
    }),
  },
};

export default List;
